import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatTooltipModule } from "@angular/material/tooltip";

import { ProfileCompletenessIndicatorComponent } from "./profile-completeness-indicator.component";

@NgModule({
  declarations: [ProfileCompletenessIndicatorComponent],
  imports: [CommonModule, MatTooltipModule],
  exports: [ProfileCompletenessIndicatorComponent],
})
export class ProfileCompletenessIndicatorModule {}
